__turbopack_context__.v({
  "benzinga-core-table-wrapper": "pricePrediction-module-scss-module__3uJwhW__benzinga-core-table-wrapper",
  "price-pred-table-wrap": "pricePrediction-module-scss-module__3uJwhW__price-pred-table-wrap",
});
